import React from 'react'
import { Box } from 'grommet'
import styled from 'styled-components'
import { daysBetween } from '../../utils'

const WrapperText = styled(Box)`
  position: relative;
  &:after {
    position: absolute;
    ${props =>
      props.position === 'right' ? `right: ${props.right}` : `left: 0px`};
    top: ${props => props.top};
    /* min-width: 10px; */
    /* min-height: 10px; */
    line-height: 10px;
    padding: 2px 4px;
    color: #fff;
    background-color: ${props => props.theme.global.colors.secondary};
    font-size: 9px;
    border-radius: 20px;
    content: 'NEW';
    font-weight: 700;
    z-index: 1;
  }
`

const WrapperDot = styled(Box)`
  position: relative;
  &:after {
    position: absolute;
    ${props =>
      props.position === 'right' ? `right: ${props.right}` : `left: 0px`};
    top: ${props => props.top};
    width: 7px;
    height: 7px;
    /* min-width: 10px; */
    /* min-height: 10px; */
    /* line-height: 10px; */
    /* padding: 2px 4px; */
    background-color: ${props => props.theme.global.colors.secondary};
    border-radius: 50%;
    content: '';
    z-index: 1;
  }
`

const NewWrapper = ({
  date = '',
  threshold = 30,
  children,
  position = 'right',
  top = '-5px',
  right = '-5px',
  dot = false,
}) => {
  if (date === '') {
    return children
  }
  const updateDate = new Date(date)

  const todayDate = new Date()
  const daysDifference = daysBetween(updateDate, todayDate)
  if (daysDifference > threshold) {
    return children
  }
  let Wrapper = WrapperText
  if (dot) {
    Wrapper = WrapperDot
  }
  return (
    <Wrapper position={position} top={top} right={right}>
      {children}
    </Wrapper>
  )
}

export default NewWrapper
